<template>
    <b-row align-h="center" class="pt-2 news-list">
        <b-col>
            <b-row align-h="center" class="mb-5 news-row" :key="item.id" v-for="(item) in newsList">
                <b-col md="8">
                    <img :src="fileResourceUrl(item.image.value)"/>
                </b-col>
                <b-col md="4">
                    <h4 v-if="item.title.value" v-html="item.title.value">{{item.title.value}}</h4>
                    <div v-html="item.description.value"></div>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'news-list',
        props: {
            newsList: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .news-list {
        .news-row img {
            width: 100%;
            object-fit: contain;
        }
    }


</style>